export default {
    name: "date_part",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Get date part %1 from %2',
                "args0": [
                    {
                        "type": "field_dropdown",
                        "name": "GRANULARITY",
                        "options": [
                            ["day of week", "DAY_OF_WEEK"],
                            ["day of month", "DAY_OF_MONTH"],
                            ["day of year", "DAY_OF_YEAR"],
                            ["aligned week of month", "ALIGNED_WEEK_OF_MONTH"],
                            ["aligned week of year", "ALIGNED_WEEK_OF_YEAR"],
                            ["month of year", "MONTH_OF_YEAR"],
                            ["year", "YEAR"],
                        ]
                    },
                    {
                        "type": "input_value",
                        "name": "DATE",
                        "check": "Date"
                    }
                ],
                "inputsInline": true,
                "output": ["String", "Number"],
                "colour": 4.5,
                "tooltip": "Get part of date",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {

        const javaChronoUnit = `java.time.temporal.ChronoField`
        const date = blocklyInstance.JavaScript.valueToCode(block, "DATE", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const granularity = block.getFieldValue("GRANULARITY");
        return [`${date}.get(Java.type("${javaChronoUnit}").${granularity})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}